import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/avatar.png'
import _imports_1 from '../assets/img/hand.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-70884f82")

_pushScopeId("data-v-70884f82")
const _hoisted_1 = { class: "chat" }
const _hoisted_2 = {
  class: "content",
  ref: "content"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "xiaofeng animate__animated animate__fadeInUp" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "avatar",
    alt: ""
  }),
  /*#__PURE__*/_createVNode("div", { class: "intro" }, [
    /*#__PURE__*/_createVNode("div", { class: "name" }, "由封面AIGC内容创作平台提供服务"),
    /*#__PURE__*/_createVNode("div", { class: "text" }, "Hi，我是AIGC小封，作为你的AI小伙伴，我随时准备为你答疑解惑。")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "xiaofeng animate__animated animate__fadeInUp animate__delay-1s" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "avatar",
    alt: ""
  }),
  /*#__PURE__*/_createVNode("div", { class: "intro" }, [
    /*#__PURE__*/_createVNode("div", { class: "name" }, "由封面AIGC内容创作平台提供服务"),
    /*#__PURE__*/_createVNode("div", {
      class: "text",
      style: {"animation-delay":"1s"}
    }, "快选择问题，来考考我吧！")
  ])
], -1)
const _hoisted_5 = { class: "xiaofeng animate__animated animate__fadeInUp animate__delay-2s" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "avatar",
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "intro" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "name" }, "由封面AIGC内容创作平台提供服务", -1)
const _hoisted_9 = {
  key: 0,
  class: "rewait"
}
const _hoisted_10 = {
  key: 1,
  style: {"display":"flex","align-items":"flex-start","flex-direction":"column"}
}
const _hoisted_11 = {
  key: 2,
  style: {"width":"100%","align-items":"flex-end"}
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("换一换")
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "xiaofeng"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "avatar",
  alt: ""
}, null, -1)
const _hoisted_16 = { class: "intro" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "name" }, "由封面AIGC内容创作平台提供服务", -1)
const _hoisted_18 = { class: "text" }
const _hoisted_19 = {
  key: 1,
  class: "user"
}
const _hoisted_20 = { class: "intro" }
const _hoisted_21 = { class: "name" }
const _hoisted_22 = { class: "text" }
const _hoisted_23 = {
  key: 2,
  class: "xiaofeng animate__animated animate__fadeInUp"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "avatar",
  alt: ""
}, null, -1)
const _hoisted_25 = { class: "intro" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "name" }, "由封面AIGC内容创作平台提供服务", -1)
const _hoisted_27 = {
  key: 0,
  style: {"display":"flex","align-items":"flex-start","flex-direction":"column"}
}
const _hoisted_28 = {
  key: 1,
  style: {"width":"100%","align-items":"flex-end"}
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("换一换")
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode("已收到，回复中请稍等..")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          (_ctx.isWait)
            ? (_openBlock(), _createBlock("div", _hoisted_9, "请稍等..."))
            : _createCommentVNode("", true),
          (_ctx.isLoad)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "text link",
                    style: `animation-delay: ${ index * 0.3 + 2 }s;`,
                    key: 'q_' + index,
                    onClick: ($event: any) => (_ctx.handleQa(item))
                  }, _toDisplayString(item.q), 13, ["onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isLoad)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode("div", {
                  class: "load animate__animated animate__fadeInUp animate__delay-3s",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleReload && _ctx.handleReload(...args)))
                }, [
                  _hoisted_12,
                  _hoisted_13
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.message, (item, mIndex) => {
        return (_openBlock(), _createBlock("div", { key: item }, [
          (item.role === 'xf')
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, _toDisplayString(item.content), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (item.role === 'user')
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode("img", {
                  src: _ctx.userInfo.avatar || 'https://yunyingcdn.thecover.cn/au_5fc6f0241061d79c680672e3/20240119/1FD79417-A8EE-AE2D-B8E4-9C41B7DF9404.png',
                  class: "avatar",
                  alt: ""
                }, null, 8, ["src"]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, _toDisplayString(item.time), 1),
                  _createVNode("div", _hoisted_22, _toDisplayString(item.content), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (item.role === 'question')
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  (item.list)
                    ? (_openBlock(), _createBlock("div", _hoisted_27, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.list, (item, index) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "text link",
                            style: `animation-delay: ${ index * 0.3 }s;`,
                            key: 'q_' + index,
                            onClick: ($event: any) => (_ctx.handleQa(item))
                          }, _toDisplayString(item.q), 13, ["onClick"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (item.list)
                    ? (_openBlock(), _createBlock("div", _hoisted_28, [
                        _createVNode("div", {
                          class: "load animate__animated animate__fadeInUp animate__delay-1s",
                          onClick: ($event: any) => (_ctx.handleReloadMesage(mIndex))
                        }, [
                          _hoisted_29,
                          _hoisted_30
                        ], 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createVNode("div", {
        class: "wait",
        style: `visibility: ${ _ctx.isChat ? '' : 'hidden' };`
      }, [
        _hoisted_31,
        _createVNode("span", {
          style: `visibility: ${ _ctx.wait ? 'hidden' :  ''};`
        }, ".", 4)
      ], 4)
    ], 512)
  ]))
})